import {
  DELETE_DEVICETYPES_CATALOG,
  DELETE_DEVICETYPES_CATALOG_SUCCESS,
  DELETE_DEVICETYPES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteDeviceTypesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_DEVICETYPES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_DEVICETYPES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_DEVICETYPES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
